<template>
  <div id="user-page">
    <b-card no-body class="h-100">
      <!-- header component -->
      <b-card-header>
        <!-- title -->
        <b-card-title class="d-flex align-items-center">
          <i class="bi bi-wordpress"></i>
          <span style="margin-left: 5px"> WordPress Scraper </span>
        </b-card-title>
        <div class="d-flex flex-wrap justify-content-end align-items-center gap-5px">
          <!-- add user button -->
          <b-button variant="outline-info" v-b-modal.modal-add-scraper>
            <feather-icon icon="PlusIcon" />
            <span>Tambah Scraper</span>
          </b-button>
          <!-- keyword filter -->
          <b-input-group class="input-group-merge" style="width: 20rem">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input placeholder="Masukkan kata kunci..." v-model="filter_data.key" />
          </b-input-group>
        </div>
      </b-card-header>
      <div>
        <!-- loader component -->
        <loader v-if="is_loading" />
        <!-- table component -->
        <dataTable 
          v-else 
          :data="table_data" 
          :editItems="editScraper" 
          :deleteItems="deleteScraper"
          :is_pagination="false" />
        <paginationInfo 
          :page="pagination.page" 
          :items="pagination.items" 
          :count="pagination.count"
          @update-value="paginationChanged" />
      </div>
    </b-card>
    <!-- add user  modal component -->
    <addScraper />
    <!-- edit user modal component -->
    <editScraper :data="scraper_data" />
  </div>
</template>
<script>
import useJwt from "@/auth/jwt/useJwt";
import dataTable from "@/views/components/dataTable.vue";
import loader from "@/views/components/loader.vue";
import addScraper from "@/views/components/wordpress/addScraper.vue";
import editScraper from "@/views/components/wordpress/editScraper.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import paginationInfo from "@/views/components/paginationInfo.vue";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BCardBody,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
  VBModal,
} from "bootstrap-vue";

export default {
  name: "Scraper",
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardSubTitle,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    paginationInfo,
    dataTable,
    loader,
    addScraper,
    editScraper,
  },
  data() {
    return {
      is_loading: true,
      filter_data: {
        key: "",
      },
      pagination: {
        page: 1,
        items: 10,
        count: 0,
      },
      table_data: {
        fields: [
          {
            key: "no",
            label: "no",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "1rem" },
          },
          {
            key: "_id",
            label: "nama website",
            sortable: true,
            thClass: "text-left",
            tdClass: "text-left",
          },
          {
            key: "url",
            label: "url scraper",
            thClass: "text-left",
            tdClass: "text-left",
          },
          {
            key: "actions",
            label: "aksi",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "5%", paddingRight: "2rem" },
          },
        ],
        items: [],
      },
      scraper_data: null,
    };
  },
  created() {
    this.getData();
  },
  watch: {
    "filter_data.key"() {
      if (
        !this.filter_data.key ||
        this.filter_data.key.trim().length == 0 ||
        this.filter_data.key.trim().length >= 2
      ) {
        this.getData();
      }
    },
  },
  methods: {
    paginationChanged(data) {
      this.pagination = data;
      this.getData();
    },
    getData() {
      this.is_loading = true;
      let params = {
        key: this.filter_data.key,
        page: this.pagination.page,
        item: this.pagination.items,
      };

      let query = Object.keys(params)
        .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== "")
        .map((key) => key + "=" + params[key])
        .join("&");

      let api = process.env.VUE_APP_API_URL + "wordpress?" + query;

      useJwt.axiosIns
        .get(api)
        .then((res) => {
          this.table_data.items = res.data.data.data || [];
          this.pagination.count = res.data.data.pagination.count || 0;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    editScraper(id) {
      let filter_val = this.table_data.items.filter((el) => el._id == id);
      let scraper = filter_val[0];
      this.scraper_data = {
        domain: scraper._id,
        _id: scraper._id,
      };
      this.$bvModal.show("modal-edit-scraper");
    },
    deleteScraper(id) {
      this.$swal({
        title: "Apakah Anda Yakin?",
        html: `<strong>${id}</strong> Akan dihapus dari daftar scraper`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Hapus!",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-info",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let api = process.env.VUE_APP_API_URL + "wordpress/delete/" + id;
          useJwt.axiosIns
            .delete(api)
            .then((res) => {
              const message = res.data.message || "Scraper berhasil dihapus.";
              this.getData();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Berhasil",
                  icon: "CheckCircleIcon",
                  variant: "success",
                  text: message,
                },
              });
            })
            .catch((err) => {
              const message = err.response?.data?.detail?.message || "Scraper gagal dihapus.";
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Gagal !",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                  text: message,
                },
              });
            });
        }
      });
    },
  },
  directives: {
    "b-modal": VBModal,
  },
};
</script>
